import { FaSmile, FaCalendarAlt, FaMapMarkedAlt } from 'react-icons/fa';
import { FaPeopleRoof } from 'react-icons/fa6';

const counter = [
    {
        id: 1,
        icon: <FaPeopleRoof />, // Roof icon
        title: 'Roof Installations',
        count: '5000',
    },
    {
        id: 2,
        icon: <FaSmile />, // Smile icon
        title: 'Satisfied Customers',
        count: '10000',
    },
    {
        id: 3,
        icon: <FaCalendarAlt />, // Calendar icon
        title: 'Years of Experience',
        count: '15',
    },
    {
        id: 4,
        icon: <FaMapMarkedAlt />, // Map icon
        title: 'Service Areas Covered',
        count: '50',
    },
];

export default counter;
